import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import {
  AssaignCampaignConfig,
  ConditionalConfig,
  ConditionalSegmentConfig,
  EmailCertifiedConfig,
  EmailConfig,
  ExperimentConfig,
  MakeOutBoundCallConfig,
  OfferPartialPaymentConfig,
  OfferPaymentAgreementConfig,
  SMSCertifiedConfig,
  SMSConfig,
  SuperEmailCertifiedConfig,
  SuperEmailConfig,
  SuperSMSCertifiedConfig,
  SuperSMSConfig,
  WaitDayOfMonthConfig,
  WaitDaysConfig,
  WaitDaysForDueDateConfig,
  WaitDaysOfWeekConfig,
} from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { WorkflowClass } from '@modules/campaigns/Domain/WorkflowClass';
import { NodeFactory } from '@modules/campaigns/Domain/Factories/NodeFactory';

export class ParseInfoFormToClassService {
  static ParseInfoFormToClass(data: any, workflow: WorkflowClass, node: NodeClass): void {
    if (!node) {
      throw new Error(`No node provided`);
    }
    if (node) {
      switch (NodeFactory.mapStringToNodeType(node.type)) {
        case NodeType.WaitDays:
          const updatedAttributes = {
            partDay: (node.config as WaitDaysConfig).partDay,
            waitDays: (node.config as WaitDaysConfig).waitDays,
            interval: (node.config as WaitDaysConfig).interval,
            ...data,
          };
          (node.config as WaitDaysConfig).partDay = updatedAttributes.partDay;
          (node.config as WaitDaysConfig).interval = updatedAttributes.interval;
          (node.config as WaitDaysConfig).waitDays =
            updatedAttributes.waitDays !== '' ? updatedAttributes.waitDays : 0;
          break;
        case NodeType.WaitDayOfWeek:
          const updatedAttributesWeek = {
            partDay: (node.config as WaitDaysOfWeekConfig).partDay,
            diaDeLaSemana: (node.config as WaitDaysOfWeekConfig).dayOfWeek,
            ...data,
          };
          (node.config as WaitDaysOfWeekConfig).partDay = updatedAttributesWeek.partDay;
          (node.config as WaitDaysOfWeekConfig).dayOfWeek = updatedAttributesWeek.dayOfWeek;
          break;
        case NodeType.WaitDaysForDueDate:
          const updatedAttributesDueDate = {
            partDay: (node.config as WaitDaysForDueDateConfig).partDay,
            waitDays: (node.config as WaitDaysForDueDateConfig).waitDays,
            antesODespues: (node.config as WaitDaysForDueDateConfig).antesODespues,
            ...data,
          };
          (node.config as WaitDaysForDueDateConfig).partDay = updatedAttributesDueDate.partDay;
          (node.config as WaitDaysForDueDateConfig).waitDays = updatedAttributesDueDate.waitDays;
          (node.config as WaitDaysForDueDateConfig).antesODespues =
            updatedAttributesDueDate.antesODespues;
          break;
        case NodeType.WaitDayOfMonth:
          const updatedAttributesMonth = {
            partDay: (node.config as WaitDaysConfig).partDay,
            dayOfMonth: (node.config as WaitDayOfMonthConfig).dayOfMonth,
            ...data,
          };
          (node.config as WaitDayOfMonthConfig).partDay = updatedAttributesMonth.partDay;
          (node.config as WaitDayOfMonthConfig).dayOfMonth = updatedAttributesMonth.dayOfMonth;
          break;
        case NodeType.SendSMS: {
          const config = node.config as SMSConfig;
          config.expirationAt = data.expirationAt;
          config.expirationDays = data.expirationDays;

          config.copyIds = data.copyIds ? [data.copyIds] : [];
          config.sendToAllContacts = data.sendToAllContacts;
          break;
        }

        case NodeType.SendCertifiedSMS: {
          const config = node.config as SMSCertifiedConfig;

          config.expirationAt = data.expirationAt;
          config.expirationDays = data.expirationDays;

          config.copyIds = data.copyIds ? [data.copyIds] : [];
          config.sendToAllContacts = data.sendToAllContacts;
          break;
        }

        case NodeType.SendEmail: {
          const config = node.config as EmailConfig;
          config.expirationAt = data.expirationAt;
          config.expirationDays = data.expirationDays;

          config.copyIds = data.copyIds ? [data.copyIds] : [];
          config.sendToAllContacts = data.sendToAllContacts;
          break;
        }

        case NodeType.SendCertifiedEmail: {
          const config = node.config as EmailCertifiedConfig;

          config.expirationAt = data.expirationAt;
          config.expirationDays = data.expirationDays;

          config.copyIds = data.copyIds ? [data.copyIds] : [];
          config.sendToAllContacts = data.sendToAllContacts;
          break;
        }

        case NodeType.SuperSendSMS: {
          const config = node.config as SuperSMSConfig;
          config.expirationAt = data.expirationAt;
          config.expirationDays = data.expirationDays;

          config.copyIds = data.copyIds ? data.copyIds : [];
          config.sendToAllContacts = data.sendToAllContacts;
          break;
        }

        case NodeType.SuperSendCertifiedSMS: {
          const config = node.config as SuperSMSCertifiedConfig;
          config.expirationAt = data.expirationAt;
          config.expirationDays = data.expirationDays;

          config.copyIds = data.copyIds ? data.copyIds : [];
          config.sendToAllContacts = data.sendToAllContacts;
          break;
        }

        case NodeType.SuperSendEmail: {
          const config = node.config as SuperEmailConfig;

          config.expirationAt = data.expirationAt;
          config.expirationDays = data.expirationDays;

          config.copyIds = data.copyIds ? data.copyIds : [];
          config.sendToAllContacts = data.sendToAllContacts;
          break;
        }

        case NodeType.SuperSendCertifiedEmail: {
          const config = node.config as SuperEmailCertifiedConfig;

          config.expirationAt = data.expirationAt;
          config.expirationDays = data.expirationDays;

          config.copyIds = data.copyIds ? data.copyIds : [];
          config.sendToAllContacts = data.sendToAllContacts;
          break;
        }

        case NodeType.AssignCampaign:
          (node.config as AssaignCampaignConfig).targetCampaignId = data.campañaId;
          break;
        case NodeType.MakeOutBoundCall:
          (node.config as MakeOutBoundCallConfig).agentId = data.agentId;
          (node.config as MakeOutBoundCallConfig).isContactAll = data.isContactAll;
          (node.config as MakeOutBoundCallConfig).isRetryFailCalls = data.isRetryFailCalls;

          break;
        case NodeType.OfferPaymentAgreement:
          (node.config as OfferPaymentAgreementConfig).expirationDays = data.expirationDays;
          (node.config as OfferPaymentAgreementConfig).numberOfInstalments =
            data.numberOfInstalments;
          break;
        case NodeType.Conditional:
          const updatedAttributesConditional = {
            targetNodeID: (node.config as ConditionalConfig).targetNodeId,
            status: (node.config as ConditionalConfig).statuses,
            ...data,
          };
          (node.config as ConditionalConfig).targetNodeId =
            updatedAttributesConditional.targetNodeID;
          (node.config as ConditionalConfig).statuses = updatedAttributesConditional.status;
          break;
        case NodeType.ConditionalSegments:
          const updatedSegmentIds = Array.isArray(data.segmentIds)
            ? data.segmentIds
            : [data.segmentIds];

          (node.config as ConditionalSegmentConfig).segmentIds = [];

          (node.config as ConditionalSegmentConfig).segmentIds = updatedSegmentIds;
          break;
        case NodeType.Experiment:
          const percentage = data.percentage;

          (node.config as ExperimentConfig).percentage = percentage;

          break;
        case NodeType.OfferPartialPayment:
          const updatedAttributesOfferPartialPayment = {
            expirationDays: (node.config as OfferPartialPaymentConfig).expirationDays,
            minimumPercentageAmount: (node.config as OfferPartialPaymentConfig)
              .minimumPercentageAmount,
            amount: (node.config as OfferPartialPaymentConfig).minimumAmount.amount,
            ...data,
          };
          (node.config as OfferPartialPaymentConfig).expirationDays =
            updatedAttributesOfferPartialPayment.expirationDays;
          (node.config as OfferPartialPaymentConfig).minimumPercentageAmount =
            updatedAttributesOfferPartialPayment.minimumPercentageAmount;
          (node.config as OfferPartialPaymentConfig).minimumAmount.amount =
            updatedAttributesOfferPartialPayment.amount;

          break;
        case NodeType.CreateLegalClaim:
          break;
        default:
          throw new Error('Invalid type of node, not found');
      }
    }

    workflow.updateNode(node);
  }
}
